import { render, staticRenderFns } from "./DeliveryMenuChip.vue?vue&type=template&id=76f1de30&scoped=true"
import script from "./DeliveryMenuChip.vue?vue&type=script&lang=js"
export * from "./DeliveryMenuChip.vue?vue&type=script&lang=js"
import style0 from "./DeliveryMenuChip.vue?vue&type=style&index=0&id=76f1de30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f1de30",
  null
  
)

export default component.exports